let VueNoticePlugin = {}
import { Message } from 'element-ui'

VueNoticePlugin.install = (Vue, store) => {
  Vue.prototype.$notice = {
    show() {
      var content = arguments.length > 0 ? arguments[0] : null
      var type = arguments.length > 1 ? arguments[1] : 'success'
      var timeout = arguments.length > 2 ? arguments[2] : 3000

      // 忽略没有定义的错误
      if (content === '' || content === undefined) {
        return
      }

      let notice = store.state.app.notice
      // Cancel the previous timer
      if (notice.timer != undefined) {
        clearTimeout(notice.timer)
      }

      let timer = setTimeout(() => {
        store.dispatch('app/updateNotice', {
          show: false,
          content: '',
          icon: '',
          timer: timer
        })
        Message.closeAll()
      }, timeout)

      let new_notice = { show: true, content: content, icon: type, timer: timer }
      Message.closeAll()
      Message({
        showClose: true,
        message: content,
        type: type,
        duration: 0
      })
      store.dispatch('app/updateNotice', new_notice)
    }
  }
}

export default VueNoticePlugin
